export default __webpack_public_path__ + "static/the-goodness-58ebae196752f0515edfc56bce768506.svg";